// @ts-strict-ignore
import {FLOWS_CONVERSION} from 'common/query-builder/query-block/properties-menu/constants';
import {OtherSegmentation} from 'common/query-builder/query-block/segment-menu/types';
import {SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {PropertyType, ResourceType} from 'common/report/constants';
import {DisplayBookmark} from 'common/report/dashboards/types';
import {FlowsReport} from 'common/report/flows/models/report';
import {FlowsBookmark} from 'common/report/flows/models/types';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {StringOperator} from 'common/widgets/property-filter-menu/models/types';

import {FlowsAIQuery} from './types';
import {getCommonEventParams, getDateRange, getPropertyFilters} from './util';

/**
 * Generate a Flows bookmark from the AI query.
 */
export function aiQueryToFlowsBookmark(aiQuery: FlowsAIQuery): DisplayBookmark<FlowsBookmark> {
  const report = new FlowsReport();

  // steps
  report.events = aiQuery.metrics.map((metric) => {
    return {
      event: getCommonEventParams(metric),
      type: SelectorTypeDefinitions.FlowsEvent,
      filters: getPropertyFilters(metric.filters),
      // todo: can we share this w/ query builder defaults?
      reverse: metric.stepsBefore ?? 0,
      forward: metric.stepsAfter ?? 3,
    };
  });

  // count type
  report.countType = aiQuery.countType;

  // chart type
  report.chartType = aiQuery.chartType;

  // conversion breakdown
  if (aiQuery.conversionBreakdown) {
    const segmentation: OtherSegmentation = {
      propertyDefaultType: PropertyType.String,
      propertyName: FLOWS_CONVERSION.value,
      propertyType: PropertyType.String,
      resourceType: ResourceType.Other,
      value: FLOWS_CONVERSION.value,
    };

    report.groupBy = [
      {
        [ResourceType.Other]: segmentation,
      },
    ];
  }

  // conversion filter
  if (aiQuery.conversionFilter) {
    report.otherFilters = [
      new PropertyFilter({
        resourceType: ResourceType.Other,
        propertyName: FLOWS_CONVERSION.value,
        propertyType: PropertyType.String,
        propertyDefaultType: PropertyType.String,
        filterOperator: StringOperator.Equals,
        filterValue: [aiQuery.conversionFilter === `did convert` ? `Converted` : `Did Not Convert`],
      }),
    ];
  }

  // filters
  const propertyFilters = getPropertyFilters(aiQuery.filters);
  report.eventFilters = propertyFilters.filter((pf) => pf.resourceType === ResourceType.Event);
  report.userFilters = propertyFilters.filter((pf) => pf.resourceType === ResourceType.User);

  // date range
  report.dateRange = getDateRange(aiQuery);

  return {
    name: aiQuery.report.name,
    type: BookmarkType.Flows,
    description: ``,
    params: report.generateBookmark(),
  };
}
